'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import { useIsMyProfile } from '../../hooks/use-is-my-profile';
import { EditButton } from '../edit-button';
import { ProfileEdit } from '../profile-edit';
import { SignOutButton } from '../sign-out-button';
import * as Styled from './user-info.styled';
interface UserInfoProps {
  avatar: string;
  username: string;
  plariumId: number;
}
export const UserInfo = React.memo(function UserInfo({
  avatar,
  username,
  plariumId
}: UserInfoProps) {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const isMyProfile = useIsMyProfile();
  return <Styled.Container>
      <Styled.Avatar src={avatar} />
      <Styled.UsernameAndPlariumIdWrapper>
        <Styled.Username {...buildQaTrackingEntityProps('newProfile.header.nickname')}>{username}</Styled.Username>
        <Styled.PlariumIdHolder>
          {profileModel.strings.plariumId}:
          <span {...buildQaTrackingEntityProps('newProfile.header.plariumId')}>{plariumId}</span>
        </Styled.PlariumIdHolder>
      </Styled.UsernameAndPlariumIdWrapper>
      {isMyProfile ? <Styled.Buttons>
          <EditButton />
          <ProfileEdit />
          <SignOutButton />
        </Styled.Buttons> : null}
    </Styled.Container>;
});